// Comprehensive Logo Database
// Using public CDN URLs for reliability

// NBA Team Logos
export const NBA_TEAM_LOGOS = {
  // By team name (normalized) - includes common aliases
  'atlanta_hawks': 'https://cdn.nba.com/logos/nba/1610612737/primary/L/logo.svg',
  'hawks': 'https://cdn.nba.com/logos/nba/1610612737/primary/L/logo.svg',
  'boston_celtics': 'https://cdn.nba.com/logos/nba/1610612738/primary/L/logo.svg',
  'celtics': 'https://cdn.nba.com/logos/nba/1610612738/primary/L/logo.svg',
  'brooklyn_nets': 'https://cdn.nba.com/logos/nba/1610612751/primary/L/logo.svg',
  'nets': 'https://cdn.nba.com/logos/nba/1610612751/primary/L/logo.svg',
  'charlotte_hornets': 'https://cdn.nba.com/logos/nba/1610612766/primary/L/logo.svg',
  'hornets': 'https://cdn.nba.com/logos/nba/1610612766/primary/L/logo.svg',
  'chicago_bulls': 'https://cdn.nba.com/logos/nba/1610612741/primary/L/logo.svg',
  'bulls': 'https://cdn.nba.com/logos/nba/1610612741/primary/L/logo.svg',
  'cleveland_cavaliers': 'https://cdn.nba.com/logos/nba/1610612739/primary/L/logo.svg',
  'cavaliers': 'https://cdn.nba.com/logos/nba/1610612739/primary/L/logo.svg',
  'cavs': 'https://cdn.nba.com/logos/nba/1610612739/primary/L/logo.svg',
  'dallas_mavericks': 'https://cdn.nba.com/logos/nba/1610612742/primary/L/logo.svg',
  'mavericks': 'https://cdn.nba.com/logos/nba/1610612742/primary/L/logo.svg',
  'mavs': 'https://cdn.nba.com/logos/nba/1610612742/primary/L/logo.svg',
  'denver_nuggets': 'https://cdn.nba.com/logos/nba/1610612743/primary/L/logo.svg',
  'nuggets': 'https://cdn.nba.com/logos/nba/1610612743/primary/L/logo.svg',
  'detroit_pistons': 'https://cdn.nba.com/logos/nba/1610612765/primary/L/logo.svg',
  'pistons': 'https://cdn.nba.com/logos/nba/1610612765/primary/L/logo.svg',
  'golden_state_warriors': 'https://cdn.nba.com/logos/nba/1610612744/primary/L/logo.svg',
  'warriors': 'https://cdn.nba.com/logos/nba/1610612744/primary/L/logo.svg',
  'houston_rockets': 'https://cdn.nba.com/logos/nba/1610612745/primary/L/logo.svg',
  'rockets': 'https://cdn.nba.com/logos/nba/1610612745/primary/L/logo.svg',
  'indiana_pacers': 'https://cdn.nba.com/logos/nba/1610612754/primary/L/logo.svg',
  'pacers': 'https://cdn.nba.com/logos/nba/1610612754/primary/L/logo.svg',
  'la_clippers': 'https://cdn.nba.com/logos/nba/1610612746/primary/L/logo.svg',
  'los_angeles_clippers': 'https://cdn.nba.com/logos/nba/1610612746/primary/L/logo.svg',
  'clippers': 'https://cdn.nba.com/logos/nba/1610612746/primary/L/logo.svg',
  'la_lakers': 'https://cdn.nba.com/logos/nba/1610612747/primary/L/logo.svg',
  'los_angeles_lakers': 'https://cdn.nba.com/logos/nba/1610612747/primary/L/logo.svg',
  'lakers': 'https://cdn.nba.com/logos/nba/1610612747/primary/L/logo.svg',
  'memphis_grizzlies': 'https://cdn.nba.com/logos/nba/1610612763/primary/L/logo.svg',
  'grizzlies': 'https://cdn.nba.com/logos/nba/1610612763/primary/L/logo.svg',
  'miami_heat': 'https://cdn.nba.com/logos/nba/1610612748/primary/L/logo.svg',
  'heat': 'https://cdn.nba.com/logos/nba/1610612748/primary/L/logo.svg',
  'milwaukee_bucks': 'https://cdn.nba.com/logos/nba/1610612749/primary/L/logo.svg',
  'bucks': 'https://cdn.nba.com/logos/nba/1610612749/primary/L/logo.svg',
  'minnesota_timberwolves': 'https://cdn.nba.com/logos/nba/1610612750/primary/L/logo.svg',
  'timberwolves': 'https://cdn.nba.com/logos/nba/1610612750/primary/L/logo.svg',
  'wolves': 'https://cdn.nba.com/logos/nba/1610612750/primary/L/logo.svg',
  'new_orleans_pelicans': 'https://cdn.nba.com/logos/nba/1610612740/primary/L/logo.svg',
  'pelicans': 'https://cdn.nba.com/logos/nba/1610612740/primary/L/logo.svg',
  'new_york_knicks': 'https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg',
  'knicks': 'https://cdn.nba.com/logos/nba/1610612752/primary/L/logo.svg',
  'oklahoma_city_thunder': 'https://cdn.nba.com/logos/nba/1610612760/primary/L/logo.svg',
  'thunder': 'https://cdn.nba.com/logos/nba/1610612760/primary/L/logo.svg',
  'okc_thunder': 'https://cdn.nba.com/logos/nba/1610612760/primary/L/logo.svg',
  'orlando_magic': 'https://cdn.nba.com/logos/nba/1610612753/primary/L/logo.svg',
  'magic': 'https://cdn.nba.com/logos/nba/1610612753/primary/L/logo.svg',
  'philadelphia_76ers': 'https://cdn.nba.com/logos/nba/1610612755/primary/L/logo.svg',
  '76ers': 'https://cdn.nba.com/logos/nba/1610612755/primary/L/logo.svg',
  'sixers': 'https://cdn.nba.com/logos/nba/1610612755/primary/L/logo.svg',
  'phoenix_suns': 'https://cdn.nba.com/logos/nba/1610612756/primary/L/logo.svg',
  'suns': 'https://cdn.nba.com/logos/nba/1610612756/primary/L/logo.svg',
  'portland_trail_blazers': 'https://cdn.nba.com/logos/nba/1610612757/primary/L/logo.svg',
  'trail_blazers': 'https://cdn.nba.com/logos/nba/1610612757/primary/L/logo.svg',
  'blazers': 'https://cdn.nba.com/logos/nba/1610612757/primary/L/logo.svg',
  'sacramento_kings': 'https://cdn.nba.com/logos/nba/1610612758/primary/L/logo.svg',
  'kings': 'https://cdn.nba.com/logos/nba/1610612758/primary/L/logo.svg',
  'san_antonio_spurs': 'https://cdn.nba.com/logos/nba/1610612759/primary/L/logo.svg',
  'spurs': 'https://cdn.nba.com/logos/nba/1610612759/primary/L/logo.svg',
  'toronto_raptors': 'https://cdn.nba.com/logos/nba/1610612761/primary/L/logo.svg',
  'raptors': 'https://cdn.nba.com/logos/nba/1610612761/primary/L/logo.svg',
  'utah_jazz': 'https://cdn.nba.com/logos/nba/1610612762/primary/L/logo.svg',
  'jazz': 'https://cdn.nba.com/logos/nba/1610612762/primary/L/logo.svg',
  'washington_wizards': 'https://cdn.nba.com/logos/nba/1610612764/primary/L/logo.svg',
  'wizards': 'https://cdn.nba.com/logos/nba/1610612764/primary/L/logo.svg',
};

// NHL Team Logos
export const NHL_TEAM_LOGOS = {
  'anaheim_ducks': 'https://assets.nhle.com/logos/nhl/svg/ANA_light.svg',
  'arizona_coyotes': 'https://assets.nhle.com/logos/nhl/svg/ARI_light.svg',
  'boston_bruins': 'https://assets.nhle.com/logos/nhl/svg/BOS_light.svg',
  'buffalo_sabres': 'https://assets.nhle.com/logos/nhl/svg/BUF_light.svg',
  'calgary_flames': 'https://assets.nhle.com/logos/nhl/svg/CGY_light.svg',
  'carolina_hurricanes': 'https://assets.nhle.com/logos/nhl/svg/CAR_light.svg',
  'chicago_blackhawks': 'https://assets.nhle.com/logos/nhl/svg/CHI_light.svg',
  'colorado_avalanche': 'https://assets.nhle.com/logos/nhl/svg/COL_light.svg',
  'columbus_blue_jackets': 'https://assets.nhle.com/logos/nhl/svg/CBJ_light.svg',
  'dallas_stars': 'https://assets.nhle.com/logos/nhl/svg/DAL_light.svg',
  'detroit_red_wings': 'https://assets.nhle.com/logos/nhl/svg/DET_light.svg',
  'edmonton_oilers': 'https://assets.nhle.com/logos/nhl/svg/EDM_light.svg',
  'florida_panthers': 'https://assets.nhle.com/logos/nhl/svg/FLA_light.svg',
  'los_angeles_kings': 'https://assets.nhle.com/logos/nhl/svg/LAK_light.svg',
  'minnesota_wild': 'https://assets.nhle.com/logos/nhl/svg/MIN_light.svg',
  'montreal_canadiens': 'https://assets.nhle.com/logos/nhl/svg/MTL_light.svg',
  'nashville_predators': 'https://assets.nhle.com/logos/nhl/svg/NSH_light.svg',
  'new_jersey_devils': 'https://assets.nhle.com/logos/nhl/svg/NJD_light.svg',
  'new_york_islanders': 'https://assets.nhle.com/logos/nhl/svg/NYI_light.svg',
  'new_york_rangers': 'https://assets.nhle.com/logos/nhl/svg/NYR_light.svg',
  'ottawa_senators': 'https://assets.nhle.com/logos/nhl/svg/OTT_light.svg',
  'philadelphia_flyers': 'https://assets.nhle.com/logos/nhl/svg/PHI_light.svg',
  'pittsburgh_penguins': 'https://assets.nhle.com/logos/nhl/svg/PIT_light.svg',
  'san_jose_sharks': 'https://assets.nhle.com/logos/nhl/svg/SJS_light.svg',
  'seattle_kraken': 'https://assets.nhle.com/logos/nhl/svg/SEA_light.svg',
  'st_louis_blues': 'https://assets.nhle.com/logos/nhl/svg/STL_light.svg',
  'tampa_bay_lightning': 'https://assets.nhle.com/logos/nhl/svg/TBL_light.svg',
  'toronto_maple_leafs': 'https://assets.nhle.com/logos/nhl/svg/TOR_light.svg',
  'vancouver_canucks': 'https://assets.nhle.com/logos/nhl/svg/VAN_light.svg',
  'vegas_golden_knights': 'https://assets.nhle.com/logos/nhl/svg/VGK_light.svg',
  'washington_capitals': 'https://assets.nhle.com/logos/nhl/svg/WSH_light.svg',
  'winnipeg_jets': 'https://assets.nhle.com/logos/nhl/svg/WPG_light.svg',
};

// MLB Team Logos
export const MLB_TEAM_LOGOS = {
  'arizona_diamondbacks': 'https://www.mlbstatic.com/team-logos/109.svg',
  'atlanta_braves': 'https://www.mlbstatic.com/team-logos/144.svg',
  'baltimore_orioles': 'https://www.mlbstatic.com/team-logos/110.svg',
  'boston_red_sox': 'https://www.mlbstatic.com/team-logos/111.svg',
  'chicago_cubs': 'https://www.mlbstatic.com/team-logos/112.svg',
  'chicago_white_sox': 'https://www.mlbstatic.com/team-logos/145.svg',
  'cincinnati_reds': 'https://www.mlbstatic.com/team-logos/113.svg',
  'cleveland_guardians': 'https://www.mlbstatic.com/team-logos/114.svg',
  'colorado_rockies': 'https://www.mlbstatic.com/team-logos/115.svg',
  'detroit_tigers': 'https://www.mlbstatic.com/team-logos/116.svg',
  'houston_astros': 'https://www.mlbstatic.com/team-logos/117.svg',
  'kansas_city_royals': 'https://www.mlbstatic.com/team-logos/118.svg',
  'los_angeles_angels': 'https://www.mlbstatic.com/team-logos/108.svg',
  'los_angeles_dodgers': 'https://www.mlbstatic.com/team-logos/119.svg',
  'miami_marlins': 'https://www.mlbstatic.com/team-logos/146.svg',
  'milwaukee_brewers': 'https://www.mlbstatic.com/team-logos/158.svg',
  'minnesota_twins': 'https://www.mlbstatic.com/team-logos/142.svg',
  'new_york_mets': 'https://www.mlbstatic.com/team-logos/121.svg',
  'new_york_yankees': 'https://www.mlbstatic.com/team-logos/147.svg',
  'oakland_athletics': 'https://www.mlbstatic.com/team-logos/133.svg',
  'philadelphia_phillies': 'https://www.mlbstatic.com/team-logos/143.svg',
  'pittsburgh_pirates': 'https://www.mlbstatic.com/team-logos/134.svg',
  'san_diego_padres': 'https://www.mlbstatic.com/team-logos/135.svg',
  'san_francisco_giants': 'https://www.mlbstatic.com/team-logos/137.svg',
  'seattle_mariners': 'https://www.mlbstatic.com/team-logos/136.svg',
  'st_louis_cardinals': 'https://www.mlbstatic.com/team-logos/138.svg',
  'tampa_bay_rays': 'https://www.mlbstatic.com/team-logos/139.svg',
  'texas_rangers': 'https://www.mlbstatic.com/team-logos/140.svg',
  'toronto_blue_jays': 'https://www.mlbstatic.com/team-logos/141.svg',
  'washington_nationals': 'https://www.mlbstatic.com/team-logos/120.svg',
};

// NFL Team Logos
export const NFL_TEAM_LOGOS = {
  'arizona_cardinals': 'https://static.www.nfl.com/image/private/f_auto/league/u9fltoslqdsyao8cpm0k',
  'atlanta_falcons': 'https://static.www.nfl.com/image/private/f_auto/league/d8m7hzpsbrl6pnqht8op',
  'baltimore_ravens': 'https://static.www.nfl.com/image/private/f_auto/league/ucsdijmddsqcj1i9tddd',
  'buffalo_bills': 'https://static.www.nfl.com/image/private/f_auto/league/giphcy6ie9mxbnldntsf',
  'carolina_panthers': 'https://static.www.nfl.com/image/private/f_auto/league/ervfzgrqdpnc7lh5gqwq',
  'chicago_bears': 'https://static.www.nfl.com/image/private/f_auto/league/ra0poq2ivwyahbaq86d2',
  'cincinnati_bengals': 'https://static.www.nfl.com/image/private/f_auto/league/okxpteoliyayufypqalq',
  'cleveland_browns': 'https://static.www.nfl.com/image/private/f_auto/league/fgbn8acp4opvkmovpwys',
  'dallas_cowboys': 'https://static.www.nfl.com/image/private/f_auto/league/ieid8hoygzdlmzo0tnf6',
  'denver_broncos': 'https://static.www.nfl.com/image/private/f_auto/league/t0p7m5cjdjy18rnzzqbx',
  'detroit_lions': 'https://static.www.nfl.com/image/private/f_auto/league/ocvxwnapdvwevupe4tpr',
  'green_bay_packers': 'https://static.www.nfl.com/image/private/f_auto/league/gppfvr7n8gljgjaqux2x',
  'houston_texans': 'https://static.www.nfl.com/image/private/f_auto/league/bpx88i8nw4nnabuq0oob',
  'indianapolis_colts': 'https://static.www.nfl.com/image/private/f_auto/league/keenqeukerqaifcxk5wa',
  'jacksonville_jaguars': 'https://static.www.nfl.com/image/private/f_auto/league/qycbib6ivrm9dqaexryk',
  'kansas_city_chiefs': 'https://static.www.nfl.com/image/private/f_auto/league/ujshjqvmnxce8m4obmvs',
  'las_vegas_raiders': 'https://static.www.nfl.com/image/private/f_auto/league/gzcojbzcyjgubgyb6xf2',
  'los_angeles_chargers': 'https://static.www.nfl.com/image/private/f_auto/league/dhfidtn8jrumakbogeu4',
  'los_angeles_rams': 'https://static.www.nfl.com/image/private/f_auto/league/pln44vuzugjgipyidsre',
  'miami_dolphins': 'https://static.www.nfl.com/image/private/f_auto/league/lits6p8ycthy9to70bnt',
  'minnesota_vikings': 'https://static.www.nfl.com/image/private/f_auto/league/teguylrnqqmfcwxvcmmz',
  'new_england_patriots': 'https://static.www.nfl.com/image/private/f_auto/league/moyfxx3dq5pio4aiftnc',
  'new_orleans_saints': 'https://static.www.nfl.com/image/private/f_auto/league/grhjkahghjkk17v43hdx',
  'new_york_giants': 'https://static.www.nfl.com/image/private/f_auto/league/t6mhdmgizi6qhndh8b9p',
  'new_york_jets': 'https://static.www.nfl.com/image/private/f_auto/league/ekijosiae96gektbo4iw',
  'philadelphia_eagles': 'https://static.www.nfl.com/image/private/f_auto/league/puhrqgj71gobgdkdo6uq',
  'pittsburgh_steelers': 'https://static.www.nfl.com/image/private/f_auto/league/xujg9t3t4u5nmjgr54wx',
  'san_francisco_49ers': 'https://static.www.nfl.com/image/private/f_auto/league/dxibuyxbk0b9ua5ih9hn',
  'seattle_seahawks': 'https://static.www.nfl.com/image/private/f_auto/league/gcytzwpjdzbpwnwxincg',
  'tampa_bay_buccaneers': 'https://static.www.nfl.com/image/private/f_auto/league/v8uqiualryypwqgvwcih',
  'tennessee_titans': 'https://static.www.nfl.com/image/private/f_auto/league/pln44vuzugjgipyidsre',
  'washington_commanders': 'https://static.www.nfl.com/image/private/f_auto/league/bc5g5cjfgym1spkjnpqp',
};

// Sportsbook Logos (using Clearbit Logo API and direct URLs)
export const SPORTSBOOK_LOGOS = {
  // Major US Sportsbooks
  'fanduel': 'https://logo.clearbit.com/fanduel.com',
  'draftkings': 'https://logo.clearbit.com/draftkings.com',
  'betmgm': 'https://logo.clearbit.com/betmgm.com',
  'caesars': 'https://logo.clearbit.com/caesars.com',
  'pointsbet': 'https://logo.clearbit.com/pointsbet.com',
  'betrivers': 'https://logo.clearbit.com/betrivers.com',
  'wynnbet': 'https://logo.clearbit.com/wynnbet.com',
  'barstool': 'https://logo.clearbit.com/barstoolsportsbook.com',
  'fox_bet': 'https://logo.clearbit.com/foxbet.com',
  'unibet': 'https://logo.clearbit.com/unibet.com',
  'bet365': 'https://logo.clearbit.com/bet365.com',
  'pinnacle': 'https://logo.clearbit.com/pinnacle.com',
  'bovada': 'https://logo.clearbit.com/bovada.lv',
  'mybookie': 'https://logo.clearbit.com/mybookie.ag',
  'betonline': 'https://logo.clearbit.com/betonline.ag',
  'heritage_sports': 'https://logo.clearbit.com/heritagesports.eu',
  'betway': 'https://logo.clearbit.com/betway.com',
  'hard_rock_bet': 'https://logo.clearbit.com/hardrock.bet',
  'tipico': 'https://logo.clearbit.com/tipico.com',
  'twinspires': 'https://logo.clearbit.com/twinspires.com',
  
  // Additional sportsbooks from OpticOdds
  'fanatics': 'https://logo.clearbit.com/fanatics.com',
  'betparx': 'https://logo.clearbit.com/betparx.com',
  'bet_parx': 'https://logo.clearbit.com/betparx.com',
  'borgata': 'https://logo.clearbit.com/borgataonline.com',
  'sleeper': 'https://logo.clearbit.com/sleeper.com',
  'underdog_sportsbook': 'https://logo.clearbit.com/underdogfantasy.com',
  'underdog': 'https://logo.clearbit.com/underdogfantasy.com',
  'novig': 'https://logo.clearbit.com/novig.com',
  'bookmaker': 'https://logo.clearbit.com/bookmaker.eu',
  'fliff': 'https://logo.clearbit.com/fliff.com',
  'rebet': 'https://logo.clearbit.com/rebet.app',
  'stn_sports': 'https://logo.clearbit.com/stnsports.com',
  'betr': 'https://logo.clearbit.com/betr.com',
  'kalshi': 'https://logo.clearbit.com/kalshi.com',
  'prophet_x': 'https://logo.clearbit.com/prophetx.co',
  'prophetx': 'https://logo.clearbit.com/prophetx.co',
  'espn_bet': 'https://logo.clearbit.com/espnbet.com',
  'espnbet': 'https://logo.clearbit.com/espnbet.com',
  'superbook': 'https://logo.clearbit.com/superbook.com',
  'betfred': 'https://logo.clearbit.com/betfred.com',
  'betanysports': 'https://logo.clearbit.com/betanysports.eu',
  'betus': 'https://logo.clearbit.com/betus.com.pa',
  'sportsbetting': 'https://logo.clearbit.com/sportsbetting.ag',
};

// Sportsbook URLs for deep link fallback
// These are the main sportsbook websites that users can navigate to
export const SPORTSBOOK_URLS = {
  // Major US Sportsbooks
  'fanduel': 'https://sportsbook.fanduel.com',
  'draftkings': 'https://sportsbook.draftkings.com',
  'betmgm': 'https://sports.betmgm.com',
  'caesars': 'https://www.caesars.com/sportsbook',
  'pointsbet': 'https://pointsbet.com',
  'betrivers': 'https://www.betrivers.com',
  'wynnbet': 'https://www.wynnbet.com',
  'barstool': 'https://www.barstoolsportsbook.com',
  'fox_bet': 'https://www.foxbet.com',
  'unibet': 'https://www.unibet.com',
  'bet365': 'https://www.bet365.com',
  'pinnacle': 'https://www.pinnacle.com',
  'bovada': 'https://www.bovada.lv',
  'mybookie': 'https://mybookie.ag',
  'betonline': 'https://www.betonline.ag',
  'heritage_sports': 'https://heritagesports.eu',
  'betway': 'https://www.betway.com',
  'hard_rock_bet': 'https://www.hardrock.bet',
  'tipico': 'https://www.tipico.com',
  'twinspires': 'https://www.twinspires.com',
  
  // Additional sportsbooks
  'fanatics': 'https://sportsbook.fanatics.com',
  'betparx': 'https://www.betparx.com',
  'bet_parx': 'https://www.betparx.com',
  'borgata': 'https://www.borgataonline.com',
  'sleeper': 'https://sleeper.com',
  'underdog_sportsbook': 'https://underdogfantasy.com',
  'underdog': 'https://underdogfantasy.com',
  'novig': 'https://novig.com',
  'bookmaker': 'https://www.bookmaker.eu',
  'fliff': 'https://www.fliff.com',
  'rebet': 'https://rebet.app',
  'stn_sports': 'https://www.stnsports.com',
  'betr': 'https://www.betr.com',
  'kalshi': 'https://kalshi.com',
  'prophet_x': 'https://prophetx.co',
  'prophetx': 'https://prophetx.co',
  'espn_bet': 'https://espnbet.com',
  'espnbet': 'https://espnbet.com',
  'superbook': 'https://www.superbook.com',
  'betfred': 'https://www.betfred.com',
  'betanysports': 'https://www.betanysports.eu',
  'betus': 'https://www.betus.com.pa',
  'sportsbetting': 'https://www.sportsbetting.ag',
  'golden_nugget': 'https://sportsbook.goldennuggetcasino.com',
  'goldennugget': 'https://sportsbook.goldennuggetcasino.com',
  'william_hill': 'https://www.williamhill.com',
  'williamhill': 'https://www.williamhill.com',
  'bally_bet': 'https://www.ballybet.com',
  'ballybet': 'https://www.ballybet.com',
  'resorts_world_bet': 'https://resortsworld.bet',
  'circa_vegas': 'https://www.circasports.com',
  'circa': 'https://www.circasports.com',
};

// Utility function to get sportsbook URL (for deep link fallback)
export const getSportsbookUrl = (bookName) => {
  if (!bookName) return null;
  
  // Normalize: lowercase, trim, replace spaces with underscores
  const normalized = bookName.toLowerCase().trim().replace(/\s+/g, '_');
  
  return SPORTSBOOK_URLS[normalized] || SPORTSBOOK_URLS[bookName.toLowerCase()] || null;
};

// Utility function to get team logo
export const getTeamLogo = (teamName, sport = 'basketball') => {
  if (!teamName) return null;
  
  // Normalize: lowercase, trim, replace spaces/dots/hyphens with underscores, remove special chars
  const normalized = teamName
    .toLowerCase()
    .trim()
    .replace(/[.\-\s]+/g, '_')
    .replace(/[^a-z0-9_]/g, '');
  
  // Try exact match first
  let logo = null;
  const logos = (() => {
    switch (sport.toLowerCase()) {
      case 'basketball':
      case 'nba':
        return NBA_TEAM_LOGOS;
      case 'hockey':
      case 'nhl':
        return NHL_TEAM_LOGOS;
      case 'baseball':
      case 'mlb':
        return MLB_TEAM_LOGOS;
      case 'football':
      case 'nfl':
        return NFL_TEAM_LOGOS;
      default:
        return null;
    }
  })();
  
  if (logos) {
    logo = logos[normalized];
    
    // If no exact match, try partial matching (for cases like "Lakers" -> "los_angeles_lakers")
    if (!logo) {
      const partialKey = Object.keys(logos).find(key => 
        key.includes(normalized) || normalized.includes(key.split('_').pop())
      );
      if (partialKey) logo = logos[partialKey];
    }
  }
  
  // If still no match and no specific sport, try all sports
  if (!logo) {
    logo = NBA_TEAM_LOGOS[normalized] || 
           NHL_TEAM_LOGOS[normalized] || 
           MLB_TEAM_LOGOS[normalized] || 
           NFL_TEAM_LOGOS[normalized];
  }
  
  return logo;
};

// Utility function to get sportsbook logo
export const getSportsbookLogo = (bookName) => {
  if (!bookName) return null;
  
  // Normalize: lowercase, trim, replace spaces with underscores
  const normalized = bookName.toLowerCase().trim().replace(/\s+/g, '_');
  
  // Also add the capitalized version to the lookup
  const result = SPORTSBOOK_LOGOS[normalized] || SPORTSBOOK_LOGOS[bookName.toLowerCase()];
  
  if (!result) {
    console.warn('[Logo] Sportsbook not found:', bookName, '→ normalized:', normalized);
  }
  
  return result;
};

// Utility function to extract team from player/selection text
export const extractTeamFromSelection = (selection, homeTeam, awayTeam) => {
  if (!selection) return null;
  
  const selectionLower = selection.toLowerCase();
  const homeLower = homeTeam?.toLowerCase() || '';
  const awayLower = awayTeam?.toLowerCase() || '';
  
  // Check if selection mentions home or away team
  if (homeLower && selectionLower.includes(homeLower)) {
    return homeTeam;
  }
  if (awayLower && selectionLower.includes(awayLower)) {
    return awayTeam;
  }
  
  return null;
};

